export const YOGA_FILE_PICKED_EVENT = "yogaFilePicked";
export const FLUTTER_PICK_MEDIA_MESSAGE = "pick_yoga_media";

/** Ask the Flutter WebView to open the native file/gallery picker. */
export function requestFlutterMediaPick() {
  if (typeof window === "undefined") return false;
  if (typeof window.GameStatus?.postMessage !== "function") return false;
  window.GameStatus.postMessage(FLUTTER_PICK_MEDIA_MESSAGE);
  return true;
}

function base64ToBytes(base64) {
  const raw = String(base64).replace(/^data:[^;]+;base64,/, "");
  const bin = atob(raw);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i += 1) arr[i] = bin.charCodeAt(i);
  return arr;
}

/**
 * Convert a payload from Flutter into a File.
 * Flutter can dispatch CustomEvent('yogaFilePicked', { detail }) or call window.receiveYogaMediaFile(detail).
 * detail: { file?, base64?, dataUrl?, name?, fileName?, mime?, mimeType? }
 */
export async function flutterPayloadToFile(detail) {
  if (!detail || typeof detail !== "object") return null;
  if (detail.file instanceof File) return detail.file;
  if (detail.file instanceof Blob) {
    const name = detail.name || detail.fileName || "upload.bin";
    const mime = detail.mime || detail.mimeType || detail.file.type || "application/octet-stream";
    return new File([detail.file], name, { type: mime });
  }

  const name = String(detail.name || detail.fileName || "upload.jpg");
  const mime = String(detail.mime || detail.mimeType || "image/jpeg");

  if (detail.base64) {
    const bytes = base64ToBytes(detail.base64);
    return new File([bytes], name, { type: mime });
  }

  if (detail.dataUrl) {
    const resp = await fetch(String(detail.dataUrl));
    const blob = await resp.blob();
    return new File([blob], name, { type: mime || blob.type || "application/octet-stream" });
  }

  return null;
}
